import { Box } from "@mui/material";
import React, { useEffect } from "react";
import Sidebar from "../../components/SidebarLayout/Sidebar";
import { useDispatch, useSelector } from "react-redux";
import DepartmentMasterContent from "../../components/Masters/DepartmentMaster/DepartmentMasterContent";
import { getDepartmentMasterList } from "../../redux/actions/mastersAction";

const DepartmentMaster = () => {
  const dispatch = useDispatch();
  const CompanyID = localStorage.getItem("companyID");

  useEffect(() => {
    dispatch(
      getDepartmentMasterList({
        companyId: CompanyID,
      })
    );
  }, []);
  return (
    <>
      <Sidebar activeTab="Masters" title="Masters">
        <Box className="globalContainer_For_Content">
          <DepartmentMasterContent />
        </Box>
      </Sidebar>
    </>
  );
};

export default DepartmentMaster;
